<div class="form-group row">
  @if (innerHTML !== undefined && innerHTML !== null) {
    <app-display-hero-slide
      [html]="innerHTML"
      [displayInTable]="displayInTable"
      [css]="rowData?.overall?.css"
      [slideId]="rowData?.overall?.id">
    </app-display-hero-slide>
  }
</div>
